import React from 'react';
import DropdownList from 'react-widgets/DropdownList';

const Dropdown = ({ children, disabled, items = [], onChange, onSelect = undefined, value, wrapper, sm, groupbyKey, placeHolder, filter }) => {
  const selectedItem = items.find((item) => JSON.stringify(item.value) === JSON.stringify(value));
  const WrapperComponent = wrapper;

  const RenderItem = ({ item }) => {
    if (!item) {
      return null;
    }
    return (
      <>
        {WrapperComponent ? (
          <WrapperComponent item={item} />
        ) : (
          <div className="d-flex align-items-center">
            {item.icon ? <span className="me-2">{item.icon}</span> : null}
            <span>{item.title}</span>
          </div>
        )}
      </>
    );
  };

  const handleChange = (selected) => {
    onChange(selected.value);
  };

  // `onSelect` fires on every pick (even when the picked item equals the
  // current value), unlike `onChange` which only fires on a change. Used by
  // `MarkHeadingDropdown` to support re-clicking the active list-structure
  // option to toggle the class off.
  const handleSelect = onSelect
    ? (selected) => {
        onSelect(selected.value);
      }
    : undefined;

  return (
    <DropdownList
      disabled={disabled}
      containerClassName={sm ? 'react-widget-sm' : ''}
      onChange={handleChange}
      onSelect={handleSelect}
      dataKey="value"
      data={items}
      value={selectedItem}
      defaultValue={value}
      renderValue={children ? () => children : RenderItem}
      renderListItem={RenderItem}
      groupBy={groupbyKey}
      placeholder={placeHolder}
      filter={filter}
      textField="title"
    />
  );
};

const DropdownButton = ({ icon, title, disabled }) => {
  return (
    <>
      <div className="d-flex align-items-center">
        {icon ? <span className="me-2">{icon}</span> : null}
        <span>{title}</span>
      </div>
    </>
  );
};

Dropdown.DropdownButton = DropdownButton;

export default Dropdown;
